import React, { FunctionComponent } from 'react';

import { MarketingConsentStep as CommonMarketingConsent } from 'scenes/common/components/Steps';
import { HomeFullPageProps } from 'scenes/home/types';

const MarketingConsentStep: FunctionComponent<
  HomeFullPageProps & { defaultStateValue?: string }
> = ({ onNext, defaultStateValue }) => (
  <CommonMarketingConsent
    defaultStateValue={defaultStateValue ?? ''}
    onNext={onNext}
  />
);

export default MarketingConsentStep;
